import { render, staticRenderFns } from "./ModelLink.vue?vue&type=template&id=0ddf4219"
import script from "./ModelLink.vue?vue&type=script&lang=js"
export * from "./ModelLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports